import React from 'react';
import { Link } from 'react-router-dom';
import {
  BugAntIcon,
  TrashIcon,
  UserMinusIcon,
  ClockIcon,
  ChartBarIcon,
  EnvelopeIcon,
  CreditCardIcon,
  UserGroupIcon,
  FireIcon,
  CameraIcon,
  CloudIcon,
  ShieldCheckIcon,
  BellAlertIcon,
} from '@heroicons/react/24/outline';

export default function DashboardPage() {
  const sections = [
    {
      title: 'Analytics',
      items: [
        {
          name: 'Founder Dashboard',
          description: 'Business metrics and KPIs overview',
          icon: ChartBarIcon,
          route: '/founder-dashboard',
          color: 'bg-purple-50 text-purple-600 border-purple-200',
        },
        {
          name: 'SendGrid',
          description: 'Email delivery and engagement analytics',
          icon: EnvelopeIcon,
          route: '/sendgrid',
          color: 'bg-blue-50 text-blue-600 border-blue-200',
        },
        {
          name: 'Stripe',
          description: 'Payment and subscription metrics',
          icon: CreditCardIcon,
          route: '/stripe',
          color: 'bg-indigo-50 text-indigo-600 border-indigo-200',
        },
        {
          name: 'User Engagement',
          description: 'DAU, WAU, MAU and retention metrics',
          icon: UserGroupIcon,
          route: '/user-engagement',
          color: 'bg-green-50 text-green-600 border-green-200',
        },
        {
          name: 'Firestore',
          description: 'Real-time database usage and costs',
          icon: FireIcon,
          route: '/firestore',
          color: 'bg-orange-50 text-orange-600 border-orange-200',
        },
        {
          name: 'Rekognition',
          description: 'Image moderation and analysis metrics',
          icon: CameraIcon,
          route: '/rekognition',
          color: 'bg-pink-50 text-pink-600 border-pink-200',
        },
        {
          name: 'R2 Storage',
          description: 'Object storage usage and bandwidth',
          icon: CloudIcon,
          route: '/r2-storage',
          color: 'bg-cyan-50 text-cyan-600 border-cyan-200',
        },
        {
          name: 'Compliance',
          description: 'Security and compliance status',
          icon: ShieldCheckIcon,
          route: '/compliance',
          color: 'bg-emerald-50 text-emerald-600 border-emerald-200',
        },
        {
          name: 'Alerts',
          description: 'System alerts and notifications',
          icon: BellAlertIcon,
          route: '/alerts',
          color: 'bg-red-50 text-red-600 border-red-200',
        },
      ],
    },
    {
      title: 'Monitoring',
      items: [
        {
          name: 'LeakHunter',
          description: 'Database connection leak detection',
          icon: BugAntIcon,
          route: '/leakhunter',
          color: 'bg-blue-50 text-blue-600 border-blue-200',
        },
        {
          name: 'Cron Jobs',
          description: 'Scheduled background job monitoring',
          icon: ClockIcon,
          route: '/cron-jobs',
          color: 'bg-green-50 text-green-600 border-green-200',
        },
      ],
    },
    {
      title: 'Data Management',
      items: [
        {
          name: 'Database Reset',
          description: 'Reset database tables for testing',
          icon: TrashIcon,
          route: '/database-reset',
          color: 'bg-red-50 text-red-600 border-red-200',
        },
        {
          name: 'User Deletion',
          description: 'Delete test users from the system',
          icon: UserMinusIcon,
          route: '/user-deletion',
          color: 'bg-orange-50 text-orange-600 border-orange-200',
        },
      ],
    },
  ];

  return (
    <div className="max-w-6xl mx-auto space-y-10">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Welcome to The Fold</h1>
        <p className="text-gray-600">
          Flock operations center for analytics, monitoring, and data management
        </p>
      </div>

      {sections.map((section) => (
        <div key={section.title}>
          <h2 className="text-lg font-semibold text-gray-700 mb-4 uppercase tracking-wide">
            {section.title}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {section.items.map((tool) => (
              <Link
                key={tool.route}
                to={tool.route}
                className={`block p-5 rounded-xl border-2 transition-all hover:shadow-lg hover:scale-[1.02] ${tool.color}`}
              >
                <tool.icon className="w-8 h-8 mb-3" />
                <h3 className="text-lg font-semibold text-gray-900 mb-1">{tool.name}</h3>
                <p className="text-sm text-gray-600">{tool.description}</p>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
